// Generated by CoffeeScript 2.7.0
var EsignatureModal, FILE_NAME, FILE_TYPE;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import SignatureMixin from 'trunks/vue/share/mixins/signature.js';

FILE_NAME = '电子签字';

FILE_TYPE = 'image/png';

export default EsignatureModal = Vue.extend({
  mixins: [SignatureMixin],
  components: {
    'modal': Modal
  },
  template: `<modal title='电子签字'
       :backdrop='true'
       class="esignature-modal"
       ref='modal'>
  <div class="form-field">
    <div class="signature_pad field-input-signature_pad">
      <div class="actions" dir='ltr'>
        <div class="btn icon-btn" @click='clear'>
          <i class="slp-clear"></i>
        </div>
      </div>
      <div class="signature_pad-canvas">
        <canvas ref='signature_pad'></canvas>
        <div class="signature_pad-tip">
          <div class="helper-text" v-if="showHelper">请在上方空白区域处签字</div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" slot='footer'>
    <button class="link-btn btn-default btn-large" @click='close'>取消</button>
    <button class="btn-large" @click='ensure'>确认</button>
  </div>
</modal>`,
  data: function() {
    return {
      file: null,
      dataUrl: ''
    };
  },
  methods: {
    ensure: function() {
      var dataUrl;
      if (this.showHelper) {
        Skylark.Bridge.newAlertify('请签字', {
          type: 'error'
        });
        return;
      }
      dataUrl = this.getSignature();
      if (this.dataUrl === dataUrl) {
        this.close();
        return;
      }
      this.dataUrl = dataUrl;
      return this.generateFile(this.dataUrl);
    },
    generateFile: function(dataUrl) {
      var file;
      file = Skylark.Helpers.Utilities.parseFile(dataUrl, {
        type: FILE_TYPE,
        name: FILE_NAME
      });
      this.files = new Skylark.Libs.Storage.Attachments([file]);
      return this.files.upload({
        uploadCompleted: () => {
          this.$emit('ensureClicked', this.files.files);
          this.files = null;
          return this.close();
        }
      });
    },
    close: function() {
      return this.$refs.modal.close();
    },
    open: function() {
      return this.$refs.modal.open();
    }
  }
});
